module.exports = __webpack_public_path__ + "static/media/0.24622f30.jpg";